export const AddHubspotAccessKeyFormData = [
    {
        label: "Hubspot Access Key",
        name: "hubspotAccessToken",
        rules: [
            {
                required: true,
                message: 'Please Input Hubspot Access Token!',
            },
        ]
    }
];